import { render } from "./Hoshinoresort.vue?vue&type=template&id=2e050635&scoped=true"
import script from "./Hoshinoresort.vue?vue&type=script&lang=js"
export * from "./Hoshinoresort.vue?vue&type=script&lang=js"

import "./Hoshinoresort.vue?vue&type=style&index=0&id=2e050635&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e050635"]])

export default __exports__